import fromPairs from 'lodash/fromPairs';
import urlLocationHelper from '@/scripts/helpers/url-location-helper';

const IS_UTM_QUERY_REGEX = /^utm_[^_]+$/;
const matches = regex => key => regex.test(key);
const matchesUtmQuery = matches(IS_UTM_QUERY_REGEX);

/**
 *
 * @param {string} [query=] URL's query string
 */
const prepareQueryString = (query = window.location.search) => {
  const filteredQueriesEntries = Object.entries(urlLocationHelper.query.parse(query))
    .filter(([key]) => !matchesUtmQuery(key));

  return (
    (filteredQueriesEntries.length > 0)
      ? urlLocationHelper.query.encode(fromPairs(filteredQueriesEntries))
      : ''
  );
};

export default {
  target: (event) => (event.currentTarget) ? event.currentTarget : event.srcElement,
  currentUrl: () => (
    window.location.protocol +
    '//' +
    window.location.hostname +
    window.location.pathname +
    prepareQueryString(window.location.search)
  ),

  /**
   * Extract sharing details from an Element
   * @param {Element} target
   * @returns {Object} Details in the form of key value pair extracted from an Element.
   *                   If no target is provided, return an empty object.
   */
  extractElementData(target) {
    if (!target) return {};

    const $target = $(target);
    return [
      'url',
      'subject',
      'body0',
      'body1',
      'body-extra',
      'tweet',
    ].reduce((acc, key) => {
      const value = $target.data(key);
      if (value) {
        acc[key] = value;
      }
      return acc;
    }, {});
  },

  spread(data, preProcessFn) {
    if (data) {
      return [typeof preProcessFn === 'function' ? preProcessFn(data) : data];
    }
    return [];
  },
};
